<script>
    import AudioRecorder from "./AudioRecorder.svelte";
    import Note from "./Note.svelte";
    import {app_state, filemanager, showLightBox} from "../stores/misc";
    import FileAttachmentList from "./FileAttachmentList.svelte";

    export let type;
    export let owner_id;
    export let notes;

    let new_note = '';
    let files = [];

    const reset = () => {
        new_note = '';
        files = [];
    };
    // $: {
    //     console.log(notes);
    // }

    let should_show_note_entry = false;
    let apply_autofocus = false;
    const addNoteButtonClicked = () => {
        apply_autofocus = true;
        should_show_note_entry = true;
    }

    let voice_recorder_sending = false;
    let voice_recorder_path = '';
    const handleVoicenote = async (e) => {
        voice_recorder_sending = true;
        let audio_blob = e.detail.audio;
        let mime_type = e.detail.mime_type.split('/')[1].split(';')[0];  // eg 'audio/webm;codec=vorbis becomes webm
        // TODO do something better to handle username, eg who it is recording the voicenote
        const url = `/api/voicenote/${$app_state.username}/${type}/${owner_id}/${mime_type}`;

        voice_recorder_path = url;

        const response = await fetch(url, {
            method: 'PUT',
            body: audio_blob
        });
        let result = await response.json();
        // console.log(response, result);
        notes.unshift(result);
        notes = notes;
        reset();
        voice_recorder_sending = false;
    };

    const handleSaveNote = async () => {
        const url = `/api/${type}/${owner_id}/note`;
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                username: $app_state.username,
                text: new_note,
                files: files
            })
        });
        let result = await response.json();
        // console.log(response, result);
        notes.unshift(result);
        notes = notes;
        reset();
    };

    const handleDeleteNote = async (e) => {
        let note_id = e.detail.id;
        const url = `/api/${type}/${owner_id}/note/${note_id}`;
        const response = await fetch(url, {
            method: 'DELETE',
        });
        let result = await response.json();
        // console.log(response, result);
        if(response.status === 200) {
            notes = notes.filter(note => note.id !== note_id);
        }
    };

    const handleCancelNoteEntry = () => {
        should_show_note_entry = false;
        reset();
    }

    let is_uploading_files = false;
    const doChooseFile = () => {
        filemanager.chooseFiles();
        is_uploading_files = true;
    };

    $: {
        if(is_uploading_files) {
            if($filemanager.files.length > 0) {
                files = files.concat($filemanager.files);
                is_uploading_files = false;
                filemanager.resetFiles();
                console.log('files added, full list =', files);
            }
        }
    }
</script>


<!-- Notes -->
<section aria-labelledby="notes-title">

    {#if !should_show_note_entry && notes.length > 0}
    <div class="bg-gray-50 px-4 py-6 sm:px-6">
        <div class="justify-stretch flex flex-col-reverse space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-y-0 sm:space-x-3 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
            <button on:click={addNoteButtonClicked}
                    type="button"
                    class="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100"
            >Add Note</button>
        </div>
    </div>
    {/if}

    {#if notes.length === 0 || should_show_note_entry}
    <!--Note Entry-->
    <div class="bg-gray-50 px-4 py-6 sm:px-6">

        <div class="min-w-0 flex-1">
            <form class="relative">
                <div class="overflow-hidden bg-white rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-indigo-600">
                    <label for="comment" class="sr-only">Add a note</label>
                    <textarea bind:value={new_note} on:blur={() => apply_autofocus = false} autofocus="{apply_autofocus}" rows="3" name="comment" id="comment" class="block w-full resize-none border-0 bg-transparent text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:py-1.5 sm:text-sm sm:leading-6" placeholder="Add a note..."></textarea>

                    <!-- Spacer element to match the height of the toolbar -->
                    <div class="py-2" aria-hidden="true">
                        <!-- Matches height of button in toolbar (1px border + 36px content height) -->
                        <div class="py-px">
                            <div class="h-9"></div>
                        </div>
                    </div>
                </div>

                <div class="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
                    <div class="flex items-center space-x-5">
                        <div class="flex items-center">
                            <button on:click={doChooseFile} type="button" class="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500">
                                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd" />
                                </svg>
                                <span class="sr-only">Attach a file</span>
                            </button>
                        </div>
                    </div>

                    <div class="flex flex-shrink-0 items-center space-x-2">
                        <button on:click|preventDefault={handleCancelNoteEntry} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Cancel</button>
                        <button on:click|preventDefault={handleSaveNote} type="submit" class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Post</button>
                        <AudioRecorder on:voicenote={handleVoicenote} sending={voice_recorder_sending}></AudioRecorder>
                    </div>
                </div>
            </form>
            <!-- TEMP! -->
            {#if voice_recorder_path !== ''}
            <div class="px-4 sm:px-6 lg:px-8 py-4 bg-yellow-100">
                <p class="block my-2">{voice_recorder_path}</p>
            </div>
            {/if}
        </div>

        {#if files.length > 0 || $filemanager.is_uploading}
            <div class="my-4">
                {#if $filemanager.is_uploading}
                    <div class="flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    ><svg class="animate-spin self-center w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                    </svg>
                        Sending..</div>
                {/if}
                <FileAttachmentList files={files}></FileAttachmentList>
            </div>
        {/if}

<!--        <div class="min-w-0 flex-1">-->
<!--            <form class="relative">-->
<!--                <div>-->
<!--                    <label for="comment" class="sr-only">About</label>-->
<!--                    <textarea bind:value={new_note} on:blur={() => apply_autofocus = false} autofocus="{apply_autofocus}" id="comment" name="comment" rows="3" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Add a note"></textarea>-->
<!--                </div>-->
<!--                <div class="mt-3 flex items-center justify-between">-->
<!--                    &lt;!&ndash;<a href="/" class="group inline-flex items-start space-x-2 text-sm text-gray-500 hover:text-gray-900">&ndash;&gt;-->
<!--                    &lt;!&ndash;<svg class="h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" x-description="Heroicon name: mini/question-mark-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">&ndash;&gt;-->
<!--                    &lt;!&ndash;<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path>&ndash;&gt;-->
<!--                    &lt;!&ndash;</svg>&ndash;&gt;-->
<!--                    &lt;!&ndash;<span>Some HTML is okay.</span>&ndash;&gt;-->
<!--                    &lt;!&ndash;</a>&ndash;&gt;-->
<!--                    <button on:click|preventDefault={handleSaveNote}-->
<!--                            type="submit"-->
<!--                            class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"-->
<!--                    >Save Note</button>-->
<!--                    <AudioRecorder on:voicenote={handleVoicenote}></AudioRecorder>-->
<!--                </div>-->
<!--            </form>-->
<!--        </div>-->
    </div>
    {/if}

    {#if notes.length > 0}
    <!--List of Notes-->
    <div class="px-4 py-6 sm:px-6">
        <ul class="">
            {#each notes as note, i (note.id)}
                {#if i === notes.length - 1}
                <li class="pb-6">
                    <Note on:noteDeleteClicked={handleDeleteNote} type={type} owner_id={owner_id} note={note}></Note>
                </li>
                {:else}
                <li class="pb-6 mb-6 border-b border-gray-200">
                    <Note on:noteDeleteClicked={handleDeleteNote} type={type} owner_id={owner_id} note={note}></Note>
                </li>
                {/if}
            {/each}
        </ul>
    </div>
    {/if}


    <!--    <div class="bg-white shadow sm:overflow-hidden sm:rounded-lg">-->

<!--        <div class="bg-gray-50 px-4 py-6 sm:px-6">-->
<!--            <div class="flex space-x-3">-->
<!--                <div class="flex-shrink-0">-->
<!--                    <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt="">-->
<!--                    <div class="h-10 w-10 rounded-full bg-orange-600"></div>-->
<!--                </div>-->
<!--                <div class="min-w-0 flex-1">-->
<!--                    <form>-->
<!--                        <div>-->
<!--                            <label for="comment" class="sr-only">About</label>-->
<!--                            <textarea bind:value={new_note} id="comment" name="comment" rows="3" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Add a note"></textarea>-->
<!--                        </div>-->
<!--                        <div class="mt-3 flex items-center justify-between">-->
                            <!--                                                    <a href="/" class="group inline-flex items-start space-x-2 text-sm text-gray-500 hover:text-gray-900">-->
                            <!--                                                        <svg class="h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" x-description="Heroicon name: mini/question-mark-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
                            <!--                                                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path>-->
                            <!--                                                        </svg>-->
                            <!--                                                        <span>Some HTML is okay.</span>-->
                            <!--                                                    </a>-->
<!--                            <button on:click|preventDefault={handleSaveNote}-->
<!--                                    type="submit"-->
<!--                                    class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"-->
<!--                            >Save Note</button>-->
<!--                            <AudioRecorder on:voicenote={handleVoicenote}></AudioRecorder>-->
<!--                        </div>-->
<!--                    </form>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->


<!--    </div>-->


</section>


<style></style>